import {useCallback, useEffect, useState} from "react";
import {getProfile} from "../api/accounts";
import {BROKER_SESSION_EVENT, brokerSession} from "./brokerSession";

/** The signed-in broker's profile. `broker` is null when signed out (or the session expired). */
export function useBroker() {
    const [state, setState] = useState({loading: !!brokerSession.get(), broker: null, error: ""});

    const load = useCallback(async () => {
        if (!brokerSession.get()) {
            setState({loading: false, broker: null, error: ""});
            return;
        }
        setState((s) => ({...s, loading: true, error: ""}));
        try {
            setState({loading: false, broker: await getProfile(), error: ""});
        } catch (err) {
            setState({loading: false, broker: null, error: err.status === 401 ? "" : err.message});
        }
    }, []);

    useEffect(() => {
        load();
        const onChange = () => { if (!brokerSession.get()) setState({loading: false, broker: null, error: ""}); };
        window.addEventListener(BROKER_SESSION_EVENT, onChange);
        return () => window.removeEventListener(BROKER_SESSION_EVENT, onChange);
    }, [load]);

    const logout = useCallback(() => brokerSession.remove(), []);

    return {...state, reload: load, setBroker: (broker) => setState((s) => ({...s, broker})), logout};
}
